import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Flex, Button, Box } from "@chakra-ui/react";
import { IoCart } from "react-icons/io5";
import { toggleCartModal } from '../actions/cartActions';

const CartFab = () => {
    const cart = useSelector((state) => state.cart);
    const { cartItems } = cart;
    const dispatch = useDispatch();
    const itemCount = cartItems.length;

    const openCartModal = () => {   
        dispatch(toggleCartModal());
    }

    if (itemCount === 0) {
        return null;
    }

    return (
        <Flex pos='fixed' bottom='10px' right='10px' h='3.5rem' w='3.5rem' zIndex={9000}>
            <Button 
                onClick={openCartModal}
                colorScheme="blue" 
                h='100%' 
                w='100%' 
                fontSize='1.5rem'
                borderRadius='100%'
                pos='relative'
            >
                <IoCart />
                {itemCount > 0 && (
                    <Box 
                        pos='absolute' 
                        top='-5px' 
                        right='-5px' 
                        bg='red.500' 
                        color='white' 
                        borderRadius='50%' 
                        w='1.5rem' 
                        h='1.5rem' 
                        display='flex' 
                        alignItems='center' 
                        justifyContent='center'
                        fontSize='0.75rem'
                    >
                        {itemCount}
                    </Box>
                )}
            </Button>
        </Flex>
    );
};

export default CartFab;